import React from 'react'

import styles from './Preloader.module.scss'

const Preloader = () => (
  <div className={styles.preloader}>
    <div className={styles.loader} />
  </div>
)

export default Preloader
